import FormatMixin from '@/modules/Application/mixins/FormatMixin';

const { formatCpfCnpj } = FormatMixin.methods;

export default {
  methods: {
    formatPersonCollection(personCollection) {
      return personCollection.map((person) => this.formatPerson(person));
    },
    formatPerson(person) {
      const identificationFormatted = formatCpfCnpj(person.identification);
      const label = `${person.name} ${person.identification} ${identificationFormatted}`;
      const personFormatted = { ...person, identificationFormatted, label };
      return personFormatted;
    },
  },
};
